/**
 * Server functions for marketing-page content. Not marked `server-only`: the
 * client imports these as RPC stubs; the compiler strips the handler bodies
 * (and the server-only imports they use) from the client bundle.
 */
import { createServerFn } from '@tanstack/react-start'

import {
  getHighlightedSnippets,
  type IntegrationSnippet,
} from '@/lib/marketing/snippets.server'

/** The "Fits into your project" code samples, highlighted server-side. */
export const getIntegrationSnippets = createServerFn({ method: 'GET' }).handler(
  async (): Promise<{ snippets: IntegrationSnippet[] }> => ({
    snippets: await getHighlightedSnippets(),
  }),
)
